import { render } from "./Intrebari.vue?vue&type=template&id=2fa5e404"
const script = {}

import "./Intrebari.vue?vue&type=style&index=0&id=2fa5e404&lang=scss"

import exportComponent from "D:\\1.Server\\Repositories\\asptmr-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QList});
